export { default as now } from './now.js';
export { default } from './date.default.js';



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/lodash-es/date.js
// module id = 743
// module chunks = 0